<template>
  <el-dialog  class="testEnvTesting_model_dialog" top="5vh" center
    title="部署-测试环境测试中" width="80%" :append-to-body="true"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="form" size="mini" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          <el-input  :disabled="true" :value="allSelect.TEXTDOMAINS[form.domain]"></el-input>
        </el-form-item>
        <el-form-item label="系统" label-width="65px">
          <el-input :disabled="true" :value="allSelect.TEXTMODULES[form.module]"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="测试环境" prop="env" :label-width="formLabelWidth">
        <el-select style="width: 35%" v-model="form.env" filterable @change="queryEnvInfo()" placeholder="请选择测试环境">
          <el-option v-for="(value, key) in ENVS" :key="key" :label="value" :value="key" />
        </el-select>
        <span v-if="nonStandard" style="margin-left: 20px; color: #F56C6C">注：非标任务只支持西域主数据库</span>
        <el-popover v-else @show="queryDeployCenterList()" placement="bottom" width="900" trigger="click">
          <el-table :cell-style="getRowClass" max-height="400" v-loading="loading.envFootprint" :data="deploy_info">
            <el-table-column fixed width="150" property="moduleEnv" label="模块环境"></el-table-column>
            <el-table-column property="name" label="姓名" min-width="120"></el-table-column>
            <el-table-column property="branch" label="分支"></el-table-column>
            <el-table-column property="startDate" label="开始时间" min-width="100" sortable></el-table-column>
            <el-table-column property="holeUpTime" min-width="100" label="占用时间" sortable></el-table-column>
            <el-table-column property="commit" label="commit"></el-table-column>
            <el-table-column fixed="right" width="220" align="center" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" :type="releaseType(scope.row.holeUpTime).type" plain
                  v-if="scope.row.platform === 'walle'" @click="handleRelease(scope.$index, scope.row)">发布({{
                    scope.row.platform
                  }})
                </el-button>
                <span v-else
                  :style="`color: ${releaseType(scope.row.holeUpTime).color};width: 91.4px;display: inline-block;text-align: center;margin-right: 10px;`">{{
                    scope.row.platform.toLocaleUpperCase()
                  }}
                </span>
                <el-button size="mini"
                  v-if="scope.row.platform !== 'docker' || releaseType(scope.row.holeUpTime).type === 'success'"
                  type="primary" plain @click="handleRorrelation(scope.$index, scope.row)">查看配置
                </el-button>
                <div style="display: flex" v-else>
                  <el-button size="mini" type="primary" plain @click="handleRorrelation(scope.$index, scope.row)">查看配置
                  </el-button>
                  <el-button size="mini" type="warning" style="margin-top: 4px;" plain
                    @click="handleReleaseOccupy(scope.$index, scope.row)">解除占用
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <span slot="reference" style="margin-left: 20px; color: #67c23a; cursor: pointer">查看环境占用情况</span>
        </el-popover>
        <span style="margin-left: 20px; color: #e6a23c" v-if="intelligentEnv">智能选择的环境为 {{
          intelligentEnv
        }}</span>
      </el-form-item>
          <el-form-item label="额外部署SQL文件" prop="env" :label-width="formLabelWidth">
            <el-button type="primary" @click="handleSqlDialogVisible('edit')">查看 / 编辑</el-button>
            <el-button type="primary" @click="handleSqlDialogVisible('info')">复制到{{ showGitDeploy ? 'GIT部署路径' : 'SQL' }}</el-button>
          </el-form-item>
          <el-form-item v-if="showGitDeploy" label="GIT部署分支" prop="ref" :label-width="formLabelWidth">
            <el-input placeholder="请输入GIT部署分支" v-model="form.ref"></el-input>
          </el-form-item>
          <el-form-item v-if="showGitDeploy" label="GIT部署路径" prop="deploy_filepath" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 16 }"
                      placeholder="请输入额外部署Git相对路径，多个以换行分隔，会以扩展名（.py/.sh/.sql/.conf等）区分部署类型" v-model="form.deploy_filepath">
            </el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <div style="border-top: 1px dashed rgb(220, 223, 230)"></div>
          </el-form-item>
          <el-form-item label="SQL" prop="sqlcontent" :label-width="formLabelWidth">
            <Codemirror v-if="dialog.sqleditor" style="margin-bottom: 10px" ref="sqleditor" :value="form.sqlcontent"
                        @changeTextarea="changeTextarea($event, 'sqlcontent')" />
            <div v-else style="height:112px;border: 1px solid #DCDFE6;"></div>
            <el-button type="warning" :loading="loading.testEnvSqlDone" @click="queryTestEnvSqlDone">测试环境执行SQL
            </el-button>
            <el-button type="primary" @click="queryActionNowLogInfo('sql')">实时日志</el-button>
            <el-button type="primary" @click="queryTestEnvSqlDoneLog">查看执行SQL记录</el-button>
            <el-button type="primary" @click="querySqlQualityTest" :loading="loading.sqlQualityTest">SQL质量检测</el-button>
          </el-form-item>
          <el-form-item v-if="nonStandard" label="行为记录" :label-width="formLabelWidth">
            <EditorComment :config="allSelect" :content="form.record" @commentData="changeRecordContent" />
            <div style="margin-top: 10px;">
              <el-button type="warning" :loading="loading.record" @click="submitRecordInfo">记录一下
              </el-button>
              <el-button type="primary" @click="lookRecordList">查看行为记录</el-button>
            </div>
          </el-form-item>
          <div v-else>
            <el-form-item :label-width="formLabelWidth">
              <div style="border-top: 1px dashed rgb(220, 223, 230)"></div>
            </el-form-item>
            <el-form-item label="代码分支" prop="branch" :label-width="formLabelWidth" >
              <div style="display: flex">
              <el-select style="width: 90%; margin-right: 10px" size="mini" @change="selectBranch" v-model="form.branch" filterable
                         placeholder="请选择代码分支" @click.native="queryDevOpsSpaceStageSelectmapApi(form.module)">
                <el-option v-for="(key, value) in BRANCHS" :key="key" :label="key" :value="value">
                </el-option>
              </el-select>
                <el-button v-if="form.branch"  type="primary" @click="copyOption(form.branch)">复制</el-button>
              </div>
            </el-form-item>
            <el-form-item label="版本" prop="commit" :label-width="formLabelWidth">
              <div style="display: flex">
                <el-select style="width: 90%; margin-right: 10px" v-model="form.commit" filterable placeholder="默认为当前分支的最新版本"  @change="changeCommit">
                  <el-option v-for="item in TEXTCOMMITS" :key="item[0]" :label="item[1]" :value="item[0]" />
                </el-select>
                <el-button :loading="loading.commit" type="primary"
                           @click="selectBranch()">刷新</el-button>
              </div>
            </el-form-item>
            <el-form-item label="占用期限" prop="due_time" :label-width="formLabelWidth">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" v-model="form.due_time" type="datetime"
                              default-time="23:59:59" placeholder="默认占用至当天结束" />
            </el-form-item>
            <el-form-item :label-width="formLabelWidth">
              <el-button :loading="loading.testEnvRelease" type="warning" @click="checkEnvReleaseOccupation">测试环境发布
              </el-button>
              <el-button type="primary" @click="queryActionNowLogInfo('env')">实时日志</el-button>
              <el-button type="primary" @click="queryDevTestdeployNotice()">开发发布提醒</el-button>
              <el-button type="primary" @click="queryTestEnvReleaseLog()">查看发布记录</el-button>
            </el-form-item>
          </div>
    </el-form>
    <div slot="footer" class="dialog-footer"><!--
      <el-button type="warning" :loading="loading.tested" @click="submit('run')">完 成</el-button>
      <el-button type="warning" :loading="loading.skip" @click="submit('skip')">跳 过</el-button>
      <el-button type="warning" @click="dialog.gobackdev = true">回 退</el-button>-->
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <!--  #region dialogVisible 部分 -->
    <el-dialog :close-on-click-modal="false" custom-class="testEnvTesting_model_dialog_child" width="80%" center
      :title="showId + '额外部署SQL文件'" :visible.sync="dialog.sqlVisible" append-to-body>
      <Codemirror v-if="dialog.sqlVisible" style="margin-bottom: 10px" sqlStyle="height:200px;" ref="sqlFileditor"
        :value="form.sqlExtracontent" @changeTextarea="changeTextarea($event, 'sqlExtracontent')" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSqlDialogVisible('save')">保存</el-button>
        <span style="font-size: 15px;color: #666;font-weight: bold;margin-left: 10px;position: absolute;bottom: 30px;"
          v-if="sqlQualityTestInfo.score < 100">
          分数:<span :style="{ color: sqlQualityTestInfo.score > 90 ? '#67C23A' : '#E6A23C' }">{{ sqlQualityTestInfo.score
          }}</span><a style="color: rgb(64, 158, 255);margin-left: 20px;" :href="sqlQualityTestInfo.origin_url"
            target="_blank" v-if="sqlQualityTestInfo.origin_url">查看报告</a>
        </span>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="testEnvTesting_model_dialog_child" width="80%" center
      :title="showId + '测试环境执行SQL'" v-if="dialog.sqlDoneVisible" :visible.sync="dialog.sqlDoneVisible" append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" v-html="webSocket.msg" class="tips-message websocket_style" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="testEnvTesting_model_dialog_child" width="80%" center
      :title="showId + 'SQL执行历史记录'" :visible.sync="dialog.sqlLogVisible" append-to-body>
      <TableFive :moduleType="form.module" :tableData="tableData.sqlList" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="testEnvTesting_model_dialog_child" width="80%" center
      :title="showId + '测试环境代码发布'" v-if="dialog.releaseResultVisible" :visible.sync="dialog.releaseResultVisible"
      append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" custom-class="testEnvTesting_model_dialog_child" width="80%" center
      :title="showId + '发布记录'" :visible.sync="dialog.releaseLogVisible" append-to-body>
      <el-tabs v-if="tableData.releaseList.length" type="border-card">
        <el-tab-pane v-for="(item, index) in tableData.releaseList" value="0" :name="String(index)" :key="index"
          :label="item.label">
          <TableOne :tableData="item.list" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="testEnvTesting_model_dialog_child" center
      :title="showId + '关联配置'" :visible.sync="dialog.rorrelationVisible" width="80%" append-to-body left>
      <pre
        style="white-space: pre-line;height: 300px;overflow-y: auto;background-color: #efefef;">{{ msg.rorrelationContentMsg }}</pre>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialog.releaseTipVisible" width="60%" center append-to-body>
      <div style="text-align:center;">该环境（{{
        ENVS[current_deploy_info.env]
      }}）已被占用至（{{ current_deploy_info.time }}），请与{{ allSelect.TEXTUSERS[current_deploy_info.name] }}（{{
  current_deploy_info.name
}}）联系，确认后再点击继续发布
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.releaseTipVisible = false">取 消</el-button>
        <el-button type="warning" @click="queryTestEnvRelease">继续发布</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialog.gobackdev" width="30%" center append-to-body>
      <div style="text-align:center;">是否确认回退？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.gobackdev = false">取 消</el-button>
        <el-button type="warning" :loading="loading.gobackdev" @click="submit('gobackdev')">继续回退</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
      :title="showId + '实时日志'" v-if="dialog.releaseResultLogVisible" :visible.sync="dialog.releaseResultLogVisible"
      append-to-body>
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="40%" center
      :title="showId + 'SQL质量检测'" :visible.sync="dialog.sqlQualityTest" append-to-body>
      <div
        style="display: flex;padding: 10px 20px;font-size: 15px;color: #666;justify-content: space-around;font-weight: bold">
        <div :style="{ color: sqlQualityTestInfo.score > 90 ? '#67C23A' : '#E6A23C' }"><span
            style="color: #666;">分数：</span>{{ sqlQualityTestInfo.score }}</div>
        <a style="color: rgb(64, 158, 255);" :href="sqlQualityTestInfo.origin_url" target="_blank"
          v-if="sqlQualityTestInfo.origin_url">查看报告</a>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="developing_model_dialog_child" width="80%" center
      :title="showId + '行为记录'" :visible.sync="dialog.recordListVisible" append-to-body>
      <TableRecord :tableData="recordList" />
    </el-dialog>
    <!--  #endregion -->
  </el-dialog>
</template>
<script>
import {
  postODUDADcreateApi,
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getEdiApi,
  postUpdateEdiApi,
  postDeployCenterApi,
  getAutoCustomerApi,
  getDevOpsSpaceListStageOutputApi,
  postDeployRecordingApi,
  getDevOpsSpaceTaskDetailApi,
  getDevOpsSpaceFindOneDemandApi,
  getDevOpsSpaceGitListApi,
  postDevOpsSpaceUpdateGitApi,
  postDevOpsSpaceCommitListApi,
  postDevOpsSpaceEnvListApi
} from "@/server/tops/devOps";
import {
  TableFive,
  TableOne,
  TableThir,
  TableRecord
} from "@/views/tops/devOps/components/table/index.js";
import {
  MetersphereTestplanBind
} from "@/views/tops/devOps/components/model/index.js";
import { Codemirror, Progress, Editor, WebSocket, EditorComment } from "@/components";
import {
  formatDate,
} from "@/views/tops/devOps/components/util.js";
import { mapState, mapMutations } from "vuex";
import BugList from './bug/bug_list.vue';
export default {
  components: { Codemirror, TableFive, Progress, TableOne, TableThir, Editor, WebSocket, MetersphereTestplanBind, EditorComment, TableRecord, BugList },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        domain: "",
        env: "intelligent",
        commit: "",
        sqlExtracontent: "",
        sqlcontent: "",
        case_content: '',
      },
      rules: {
        env: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: "140px",
      ENVS: {},
      dialog: {
        sqlVisible: false,
        releaseResultVisible: false,
        sqlDoneVisible: false,
        sqlLogVisible: false,
        rorrelationVisible: false,
        releaseLogVisible: false,
        releaseTipVisible: false,
        gobackdev: false,
        releaseResultLogVisible: false,
        sqleditor: true,
        sqlQualityTest: false,
        recordListVisible: false
      },
      loading: {
        testEnvSqlDone: false,
        testEnvRelease: false,
        tested: false,
        envFootprint: false,
        commit: false,
        skip: false,
        dialog: true,
        gobackdev: false,
        sqlQualityTest: false,
        record: false
      },
      tableData: {
        sqlList: [],
        releaseList: [],
      },
      msg: {
        rorrelationContentMsg: "",
        codeQualityInspectUrlMsg: "",
      },
      // #region 环境部分
      deploy_info: [],
      current_deploy_info: {},
      intelligentEnv: "",
      // #endregion

      // 版本列表
      TEXTCOMMITS: {},
      BRANCHS: {},
      showId: '',
      sqlQualityTestInfo: {},
      editorModule: false,
      recordList: [], // 行为记录列表
      activeName: 'strategy'
    };
  },
  async created() {
    const {
      id,
      module,
      taskName = "",
    } = this.formInfo;
    this.showId = `【${id}】`
    this.form = { ...this.form, id, module, taskName };
    if(id) await this.queryDevOpsSpaceTaskDetail();
   // await this.queryDevOpsSpaceListStageParmInfo();
    //await this.queryDevOpsSpaceStageSelectmapApi(module);
    await  this.UpdateGitApi(module);
    await  this.selectBranch();
    await  this.getEnvList();
    if(this.form.demandId) await this.getDemandetail(this.form.demandId);
  },
  computed: {
    ...mapState({
      progressBar: (state) => state.devOps.PROGRESSSBAR,
      allSelect: (state) => state.devOps.ALLSELECT,
      userAuthority: (state) => state.devOps.USER.authority,
      webSocket: (state) => state.devOps.WEBSOCKET
    }),
    techReviewerCh() {
      let names = '';
      return names;
    },
    showGitDeploy() {
      const { module = '', domain = '' } = this.form;
      const newOrigin = `${module}.${domain}`;
      const origins = ['odoo.ehsy.com', 'mall.raxwell.cn']
      return origins.includes(newOrigin);
    },
    modules() {
      let obj = {}
      const MODULESARR = this.allSelect.MODULESARR || [];
      MODULESARR.filter(itm => itm[2] === this.form.domain).forEach((item) => {
        if (item[0].startsWith('非标-')) return;
        obj[item[1]] = item[0];
      });
      return obj
    },
    nonStandard() { // 非标系统标识
      return this.form.module.startsWith('非标-')
    }
  },
  updated() {
    this.scrollToBottom({ bind: this, refName: 'webSocket' })
  },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    // 环境占用情况样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex)
      if (columnIndex === 4) {
        return `color:${this.releaseType(row.holeUpTime).color};`
      }
    },
    // 获取任务详情
    async queryDevOpsSpaceTaskDetail() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceTaskDetailApi({
          taskId: this.formInfo.id || "",
          space: 'producerSpace',
        });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
        };
      } catch (error) {
        this.$notify({
          message: error || "获取任务详情失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    // 获取需求详情
    async getDemandetail(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceFindOneDemandApi({id:id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          pm:info.pm,
        };
        if (info.details) { this.showDetails = true };
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }
    },
    changeCommit(val){
      this.form.commit = val;
      this.$forceUpdate();
    },
    getEnvList(){
      let params = {
        module_name: this.form.module || "BACKEND",
        branch: this.form.branch || "",
        stage_env: 'test',
        domain: this.form.domain
      };
      postDevOpsSpaceEnvListApi(params).then((ret)=>{
        let envs = {};
        ret.data.envs.map((item) => {
          return (envs[item[1]] = item[0]);
        });
        this["ENVS"] = envs;

      });
    },
    // Vue 方法，用于复制选中的 el-select 选项值
    copyOption(value) {
      const input = document.createElement('input');
      input.value = value;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '已复制到剪贴板',
        type: 'info'
      });
    },
    hiddleAction(a){
      if(!a){
        this.copyOption(this.form.branch);
      }
    },
    selectBranch() {
      let params = {
        module_name: this.form.module || "BACKEND",
        branch: this.form.branch || "",
        stage_env: 'test',
        domain: this.form.domain
      };
      postDevOpsSpaceCommitListApi(params).then((ret)=>{
        this["TEXTCOMMITS"] = ret.data?.commits?.map((v) => {
          return [v.split(" ")[0], v];
        });
        this.form.commit = ret.data.commits[0]?.split(" ")[0] || "";
        return;
      });
      //this.queryDevOpsSpaceStageSelectmapApi(this.form.module, 'commit')
    },
    selectModule() {
      this.form.branch = 'master';
      this.form.env = 'intelligent';
      this.queryDevOpsSpaceStageSelectmapApi(this.form.module)
    },
    // 修改富文本内容
    changeRecordContent({ text, cid, show }) {
      this.form.record = text
    },
    async UpdateGitApi(module) {
      try {
        const ret = await postDevOpsSpaceUpdateGitApi({
          module_name: module || "BACKEND",
          branch: this.form.branch || "",
          stage_env: 'test',
          domain: this.form.domain
        });
      } catch (error) {
        this.$notify({
          message: error || "更新分支失败",
          type: "error",
        });
      }
    },
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi(module, type) {
      try {
        this.loading.commit = true;
        const ret = await getDevOpsSpaceGitListApi({
          module_name: module || "BACKEND",
          branch: this.form.branch || "",
          stage_env: 'test',
          domain: this.form.domain
        });
        if (type === 'commit') {
          this["TEXTCOMMITS"] = ret.data?.commits?.map((v) => {
            return [v.split(" ")[0], v];
          });
          this.form.commit = ret.data.commits[0]?.split(" ")[0] || "";
          return;
        };
     /*   let envs = {};
        ret.data.envs.map((item) => {
          return (envs[item[1]] = item[0]);
        });
        this["ENVS"] = envs;*/
        this.queryEnvInfo();
        let branchs = {}
        ret.data.branchs.map((item) => { branchs[item] = item; });
        this['BRANCHS'] = branchs;
     /*   this["TEXTCOMMITS"] = ret?.commits?.map((v) => {
          return [v.split(" ")[0], v];
        });*/
       // this.form.commit = ret.data.commits[0]?.split(" ")[0] || "";
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      } finally {
        this.loading.commit = false;
        this.loading.dialog = false;
      }
    },
    // 获取开发中任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      try {
        const { id = "", demandId = "" } = this.form;
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id: "6",
          task_id: id,
          pid: demandId,
        });
        if (ret.status === "success") {
          const { common_branch: branch, env = '', due_time = '' } = ret.data || {};
          this.form = {
            ...this.form,
            branch,
            env,
            sqlcontent: "",
            due_time
          };
        } else {
          this.$notify({
            message: ret.error || "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading.dialog = false;
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step,true,this.form.id);
    },
    //设置sql语句
    changeTextarea(val, type) {
      this.$set(this.form, type, val);
    },
    // 编辑额外部署sql文件
    async handleSqlDialogVisible(type) {
      const { id, demandId } = this.form;
      let ret = {};
      try {
        switch (type) {
          case "info":
            this.dialog.sqleditor = false;
            ret = await getEdiApi({ id, pid:demandId });
            this.showGitDeploy ? this.form.deploy_filepath = ret.data : this.form.sqlcontent = ret.data;
            break;
          case "edit":
            ret = await getEdiApi({ id, pid: demandId });
            this.form.sqlExtracontent = ret.data || "";
            this.sqlQualityTestInfo = {};
            break;
          case "save":
            ret = await postUpdateEdiApi({
              id,
              content: this.form.sqlExtracontent,
              pid: demandId,
            });
            break;
          default:
            break;
        }
        if (ret.status === "success") {
          if (type === "info") return;
          this.dialog.sqlVisible = type === "edit" ? true : false;
        } else {
          if (type === 'save') {
            this.sqlQualityTestInfo = ret.data.data;
            this.dialog.sqlVisible = true;
            this.$notify({
              message: "保存失败",
              type: "error",
            });
            return;
          };
          this.$notify({
            message: "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.dialog.sqleditor = true;
      }
    },
    // 获取智能选择环境
    async queryEnvInfo() {
      const { env = "", id: task_id = "", demandId = "" } = this.form;
      if (env !== "intelligent") return (this.intelligentEnv = "");
      if (Object.keys(this['ENVS']).length < 2) return (this.intelligentEnv = "此系统暂时无环境，请直接跳过")
      const param = {
        action: "runget",
        stage_id: "6",
        task_id,
        stage_name: "tester_testCodeDeploy",
        env,
        pid: demandId,
      };
      try {
        this.intelligentEnv = "";
        const ret = await postDevopsSpaceStageActionApi(param);
        if (this.form.env && this.form.env !== 'intelligent') return;
        if (typeof ret === 'string') {
          this.intelligentEnv = this.form.env = ret || "";
        }else{
          this.intelligentEnv = this.form.env =  "";
        }
      } catch (error) {
        this.intelligentEnv = "";
        this.form.env = "";
      }
    },
    // 获取环境占用列表
    async queryDeployCenterList() {
      try {
        this.loading.envFootprint = true;
        const { module = "", demandId = "", domain = '' } = this.form;
        const ret = await postDeployCenterApi({
          action: "add",
          services: module ? [module] : [],
          pid: demandId,
          env: 'test',
          domain
        });
        let deploy_info = [];
        ret[module]?.deploy_info?.forEach((item) => {
          item?.records.forEach((itm) => {
            deploy_info.push({
              moduleEnv: itm[2],
              name: itm[0],
              branch: itm[4],
              rorrelation_url:
                item.config_url_prefix + itm[2] + item.config_url_postfix,
              release_url: itm[1],
              holeUpTime: itm[6],
              commit: itm[3],
              startDate: itm[5],
              platform: item.platform,
              record_id: itm[8] || ''
            });
          });
        });
        deploy_info.sort(function (a, b) {
          return new Date(a.holeUpTime) - new Date(b.holeUpTime);
        });
        this.deploy_info = deploy_info;
      } catch (error) {
      } finally {
        this.loading.envFootprint = false;
      }
    },
    // 解除环境占用
    async handleReleaseOccupy(index, row) {
      try {
        const param = {
          action: "deploy_update_duetime",
          record_id: row.record_id
        }
        const ret = await postDeployRecordingApi(param)
        this.$notify({
          message: ret.msg,
          type: ret.status === 'success' ? "success" : "error",
        })
        this.queryDeployCenterList()
      } catch (error) {
        this.$notify({
          message: "数据错误",
          type: "error",
        })
      }
    },
    // 发布类型判断
    releaseType(time) {
      if (!time) return { type: "success", color: '#67C23A' };
      let t = this.$moment().diff(time, "hour");
      if (t <= -24) {
        return { type: "danger", color: '#F56C6C' };
      } else if (t >= 0) {
        return { type: "success", color: '#67C23A' };
      } else {
        return { type: "warning", color: '#E6A23C' };
      }
    },
    // 环境占用发布
    handleRelease(index, row) {
      window.open(row.release_url);
    },
    // 关联配置
    async handleRorrelation(index, row) {
      try {
        const ret = await getAutoCustomerApi(row.rorrelation_url);
        this.msg.rorrelationContentMsg = ret || "";
        if (ret) {
          this.dialog.rorrelationVisible = true;
        }
      } catch (error) {
        this.msg.rorrelationContentMsg = "";
        this.dialog.rorrelationVisible = false;
      }
    },
    // 测试环境sql 执行成功失败判断
    isSqlSuccess(output = {}) {
      if (typeof output === 'string') return false
      let flag = true;
      ["sql", "script", "conf"].forEach((i) => {
        if (output[i].length && output[i][0].code !== 0) {
          flag = false;
        }
      });
      return flag && output?.msg?.code === 0;
    },
    // 测试环境sql执行
    async queryTestEnvSqlDone() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading.testEnvSqlDone = true;
          this.dialog.sqlDoneVisible = true;
          const cacheDate = new Date();
          const {
            module = "",
            ref = "",
            deploy_filepath = "",
            env = "test",
            id = "",
            demandId = "",
            sqlcontent = "",
            devloper = ''
          } = this.form;
          let param = {
            action: "run",
            stage_id: 5,
            task_id: id,
            stage_name: "tester_testExtraDeploy",
            module_type: module,
            env,
            sqlcontent,
            pid: demandId,
            user_rd:devloper.nameEn ? devloper.nameEn: "",
          };
          if (module === "odoo") {
            param.ref = ref;
            param.deploy_filepath = deploy_filepath;
          }
          const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          this.openWebSocket({ url: '/ws/devops', params: { pid: demandId, task_id: id, stage_id: 5, username }, title: '测试环境sql部署中' })
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            const output = ret?.data?.output || {};
            let isSuccess = this.isSqlSuccess(output);
            this.timeOutSetProgressBar(`SQL执行${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
            if (typeof output === 'string') {
              this.$notify({
                message: output || "数据错误",
                type: "error",
              });
            }
          } catch (error) {
            this.dialog.sqlDoneVisible = false;
            this.$notify({
              message: error || "数据错误",
              type: "error",
            });
          } finally {
            this.loading.testEnvSqlDone = false;
          }
        }
      })
    },
    // 获取sql执行记录
    async queryTestEnvSqlDoneLog() {
      try {
        const { id, demandId } = this.form;
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id: "5",
          task_id: id,
          pid: demandId,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.tableData.sqlList = instance.map((item) => {
            return {
              state: this.isSqlSuccess(item?.output) ? 0 : 1,
              content: item.content,
              logtime: item.logtime,
              deploy_filepath: item?.output?.msg?.parms?.deploy_filepath || "",
              sqlcontent: item?.output?.msg?.parms?.sqlcontent || "",
              module_type: item?.output?.msg?.parms?.module_type || "",
            };
          });
          this.dialog.sqlLogVisible = true;
        }
      } catch (error) {
        this.tableData.sqlList = [];
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 查看发布环境占用情况
    async checkEnvReleaseOccupation() {
     // await this.queryDeployCenterList()
      let flag = false;
      this.deploy_info.some(itm => {
        const name = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
        const { module = '', env = '', domain = '' } = this.form;
        if ((itm.moduleEnv === `${module}-${env}.${domain}`) && itm.name !== name) {
          if (!itm.holeUpTime) return;
          const compareTime = Date.parse(itm.holeUpTime) > Date.now()
          if (compareTime) {// true提醒 false不提醒
            this.current_deploy_info = {
              env: env,
              time: itm.holeUpTime,
              name: itm.name
            }
            flag = true;
          }
        }
      })

      if (flag) {
        this.dialog.releaseTipVisible = true;
      } else {
        this.queryTestEnvRelease()
      }
    },
    // 实时日志
    async queryActionNowLogInfo(type) {
      const {
        id: task_id = "",
        demandId = ''
      } = this.form;
      const stage_id = type === 'sql' ? 5 : 6;
      this.dialog.releaseResultLogVisible = true;
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      this.openWebSocket({
        url: '/ws/devops',
        params: { pid: demandId, task_id, stage_id, username },
        title: '实时日志'
      })
    },
    // 测试环境发布
    async queryTestEnvRelease() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            module = "",
            due_time = "",
            branch = "",
            commit = "",
            env = "",
            domain = "",
            id = "",
            demandId = "",
            devloper = '',
            pm = '',
            tester = '',
          } = this.form;
          this.dialog.releaseTipVisible = false;
          this.loading.testEnvRelease = true;
          this.dialog.releaseResultVisible = true;
          const cacheDate = new Date();
          const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          this.openWebSocket({ url: '/ws/devops', params: { pid: demandId, task_id: id, stage_id: 6, username }, title: '开始代码发布', apiCount: 1 })
          try {
            const param2 = {
              pid: demandId,
              action: "run",
              stage_id: 6,
              task_id: id,
              stage_name: "tester_testCodeDeploy",
              domain,
              module,
              due_time,
              branch,
              commit,
              env,
              user_rd: devloper.nameEn?devloper.nameEn : '',
              user_qa: tester.nameEn?tester.nameEn : '',
              notice: 'dev_deploy'
            };
            const ret2 = await postDevopsSpaceStageActionApi(param2);
            const output = ret2?.data?.output || {};
            if (typeof output === 'string') {
              this.$notify({
                message: output || "数据错误",
                type: "error",
              });
            }
            const isSuccess = typeof output === 'string' ? false : output?.deploy[0]?.code === 0;
            this.timeOutSetProgressBar(`发布${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
          } catch (error) {
            this.timeOutSetProgressBar('发布失败')
          } finally {
            this.loading.testEnvRelease = false;
          }
        }
      })
    },
    // 延迟设置进度条
    timeOutSetProgressBar(completeInfo, status = 'exception') {
      const initProgressBar = {
        percentage: 100,
        title: this.form.module || '',
        customColor: "",
      }
      setTimeout(() => {
        this.setProgressBar({
          ...initProgressBar,
          completeInfo,
          status,
        });
      }, 500)
    },
    // 获取测试环境历史执行信息
    async queryTestEnvReleaseLog(stage_id) {
      const { demandId = "", id = "" } = this.form;
      try {
        Promise.all([getDevOpsSpaceListStageOutputApi({
          stage_id: 2,
          task_id: id,
          pid: demandId
        }), getDevOpsSpaceListStageOutputApi({
          stage_id: 6,
          task_id: id,
          pid: demandId
        })]).then((list) => {
          this.tableData.releaseList = []
          list.forEach((itm, idx) => {
            let obj = {
              label: idx === 0 ? '代码质量检测' : '测试环境发布',
              list: JSON.parse(itm.data) || []
            }
            obj.list.map((im, ix) => {
              im.content = JSON.stringify(im.output, null, 2)
              return im;
            });
            this.tableData.releaseList.push(obj);
          })
          this.dialog.releaseLogVisible = true;
        })
      } catch (error) {
        this.tableData.releaseList = [];
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // Sql质量检测
    async querySqlQualityTest() {
      try {
        this.loading.sqlQualityTest = true;
        const param = {
          action: "sql_assess",
          task_id: this.form.id,
          content: this.form.sqlcontent
        }
        const ret = await postDevopsSpaceStageActionApi(param);
        if (ret.status === 'success') {
          this.sqlQualityTestInfo = ret.data;
          this.dialog.sqlQualityTest = true;
        }
      } catch (error) {

      } finally {
        this.loading.sqlQualityTest = false;
      }
    },
    // 测试完成跳过返回
    async submit(action) {
      if (action !== 'run') {
        this.submitApi(action)
        return;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.submitApi(action)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 开发发布提醒
    async queryDevTestdeployNotice() {
      try {
        const {
          id = "",
          demandId = "",
        } = this.form;
        const params = {
          task_id: id,
          pid: demandId,
          action: 'dev_testdeploy_notice'
        }
        const ret = await postDevopsSpaceStageActionApi(params)
        let output = ret?.data?.output
        this.$notify({
          message: typeof output == 'string' ? output : '未获取到信息',
          type: ret.status === 'success' ? "success" : "error",
        });
      } catch (error) {
        this.$notify({
          message: error || "数据异常",
          type: "error",
        });
      }
    },
    async submitApi(action) {
      const {
        id = "",
        demandId = '',
        case_content = "",
        devloper = '',
        pm = '',
        tester = "",
        test_status = ''
      } = this.form;
      const param = {
        action,
        case_content,
        stage_id: 7,
        stage_name: "tester_testCaseTest",
        task_id: id,
        pid: demandId,
        user_rd: devloper.nameEn ? devloper.nameEn: "",
        user_pm: pm.nameEn?pm.nameEn : '',
        user_qa: tester.nameEn?tester.nameEn : '',
        test_status
      };
      this.$set(this.loading, action === 'run' ? 'tested' : action, true)
      try {
        const ret = await postDevopsSpaceStageActionApi(param);
        let info = '';
        let output = ret?.data?.output;
        let success = false;
        if (action === 'run' && typeof output != 'string') {
          info = output?.case[0].msg
          success = output?.case[0].code === 0
        }
        if (action === 'skip' && typeof output != 'string') {
          info = success = output?.msg;
        }

        if (action === 'gobackdev' && typeof output != 'string') {
          info = output?.msg
          success = output?.code === 0;
        }
        this.$notify({
          message: typeof output == 'string' ? output : info,
          type: success ? "success" : "error",
        });
        if (success) {
          setTimeout(() => {
            //const nextStep = action === 'gobackdev' ? 'developing' : 'preEnvTesting';
            //this.handleClose(nextStep)
            const nextStep =  'preEnvTesting';
            this.handleClose(nextStep)
          }, 1500)
        }
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.loading.tested = false;
        this.loading.skip = false;
        this.loading.gobackdev = false;
      }
    },
    // 提交非标记录
    async submitRecordInfo() {
      try {
        const { demandId, id: task_id, domain, module, devloper, record, tester } = this.form;
        if (!record) return;
        this.loading.record = true;
        const ret = await postDevopsSpaceStageActionApi({ stage_name: 'tester_testCodeDeploy', action: 'runactionrecord', pid: demandId, stage_id: 6, task_id, domain, module, user_rd: devloper.nameEn ? devloper.nameEn: "", record, user_qa: tester.nameEn?tester.nameEn : '' })
        const actionRecord = ret.data?.output?.actionRecord || [];
        if (actionRecord[0]?.code === 0) {
          this.$notify({
            message: actionRecord
            [0]?.msg,
            type: "success",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || '记录保存失败',
          type: "error",
        })
      } finally {
        this.loading.record = false;
      }
    },
    // 查询历史非标记录
    async lookRecordList() {
      try {
        const {
          id: task_id,
          demandId
        } = this.form;
        const ret = await getDevOpsSpaceListStageOutputApi({
          pid: demandId,
          stage_id: 6,
          task_id,
        });
        if (ret.status === 'success') {
          this.recordList = JSON.parse(ret.data || '[]');
          this.dialog.recordListVisible = true;
        } else {
          this.recordList = []
        }
      } catch (error) {
        this.recordList = []
        this.$notify({
          message: error || '记录查询失败',
          type: "error",
        })
      }
    },
    // 富文本事件
    changeContent(val) {
      this.form.case_content = val;
    }
  },
};
</script>
<style lang="scss">
.testEnvTesting_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.testEnvTesting_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}
</style>
